"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.montageSN = exports.dataCleaning = exports.antiShake = exports.logOut = exports.login = void 0;
const auth_utils_1 = require("@star-charge/auth-utils");
//登录
const login = (init) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const loginRes = yield (0, auth_utils_1.ssoGetUserInfo)().catch((error) => {
        if (error.code === "E00005") {
            (0, auth_utils_1.ssoRedirectFunction)();
        }
    });
    if (loginRes) {
        localStorage.setItem("userInfo", JSON.stringify(loginRes.model));
        // @ts-ignore
        (_b = (_a = window === null || window === void 0 ? void 0 : window.zhuge) === null || _a === void 0 ? void 0 : _a.identify) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = loginRes.model) === null || _c === void 0 ? void 0 : _c.userAccount, loginRes.model);
        init();
    }
});
exports.login = login;
//退出登录
const logOut = () => __awaiter(void 0, void 0, void 0, function* () {
    yield (0, auth_utils_1.ssoLogout)();
    (0, auth_utils_1.ssoRedirectFunction)();
});
exports.logOut = logOut;
//防抖
const antiShake = (fn, delay) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn.apply(null, args);
        }, delay);
    };
};
exports.antiShake = antiShake;
// //过滤表格脏数据
const dataCleaning = (data, char) => {
    console.log(data);
    return data.map((item) => {
        for (const key in item) {
            console.log("vae", item[key]);
            if (!((item[key] && item[key] !== "null") || item[key] === 0)) {
                item[key] = char;
            }
        }
        return item;
    });
};
exports.dataCleaning = dataCleaning;
// 拼接SN
const montageSN = (value) => {
    if (/^SN.*/.exec((value || "").toUpperCase())) {
        return value.toUpperCase();
    }
    return `SN${(value || "").toUpperCase().replace(/^(S)?(N)?(.*)/, "$3")}`;
};
exports.montageSN = montageSN;
